





























































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  CreateGripAnalysisBarrierPayload,
  CreateGripAnalysisEnablerPayload,
  CreateGripAnalysisStrategyPayload,
  CreateGripBarrierBase,
  GripAnalysisBarrier,
  GripAnalysisDTO,
  GripItemType,
  GripBarrierDTO,
  GripBarrierStatus,
  GripItemReloadDTO,
  UpdateGripAnalysisEnablerPayload,
  UpdateGripAnalysisStrategyPayload,
  UpdateGripBarrierBase,
} from '../../../store/types/grip.types';
import BaseLoading from '../../../components/base/BaseLoading.vue';
import BarrierModal from '../Barrier/BarrierModal.vue';
import DeleteModalBox from '../../../components/DeleteModalBox.vue';
import GripAnalysisEnablers from './GripAnalysisEnablers.vue';
import { namespace } from 'vuex-class';
import { showUnsavedChangesDialog } from '@/utils/dialog.util';

const unsavedChangesGuard = namespace('unsavedChangesGuard');

@Component({
  components: {
    BaseLoading,
    BarrierModal,
    DeleteModalBox,
    GripAnalysisEnablers,
  },
})
export default class GripAnalysisBarriers extends Vue {
  @Prop() public projectId!: number;
  @Prop() public isDataCollector!: boolean;
  @Prop() public isSideBarOpen!: boolean;
  @Prop() public gripAnalysisDetails!: GripAnalysisDTO;
  @Prop() public updatedItem!: GripItemReloadDTO;
  public isGripAnalysisBarriersLoading: boolean = false;
  public showBarrierDraggableBox: boolean = true;
  public itemList: GripAnalysisBarrier[] = [];
  public tempDirtyBarrier: CreateGripBarrierBase = {
    title: '',
    description: '',
    action: true,
    reason: null,
    links: [],
    attachments: [],
    gripDomainCategoryId: null,
  };
  public modalKey: number = Math.floor(Math.random() * 999);
  public isModalActive: boolean = false;
  public isNew: boolean = false;
  public gripBarrierDetailsForEdit: GripBarrierDTO | null = null;
  public isMinimized: boolean = false;

  @unsavedChangesGuard.State('userSelectedKeepEditing')
  public userSelectedKeepEditing!: boolean;

  @unsavedChangesGuard.Action('notifyKeepEditingSelected')
  public notifyKeepEditingSelected!: () => void;

  @unsavedChangesGuard.Action('resetKeepEditingFlag')
  public resetKeepEditingFlag!: () => void;

  get editingBarrierId(): number | null {
    return this.isModalActive && !this.isNew && this.gripBarrierDetailsForEdit
      ? this.gripBarrierDetailsForEdit.id
      : null;
  }

  public getUpperCase(value: string): string {
    return value.toUpperCase();
  }

  public updated(): void {
    if (this.updatedItem.item === GripItemType.AnalysisBarrier) {
      const element = document.getElementById(
        this.updatedItem.item + '_' + this.updatedItem.id,
      );
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    if (this.showBarrierDraggableBox) {
      const element = document.getElementById('contentIdForAddBarriers');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  @Watch('gripAnalysisDetails', { deep: true, immediate: true })
  public onGripAnalysisDetailsChanged(): void {
    if (
      this.gripAnalysisDetails &&
      this.gripAnalysisDetails.gripAnalysisBarriers
    ) {
      // Create a new sorted array for itemList to ensure reactivity
      // and to avoid mutating the prop.
      // The barriers are already filtered for ACTIVE status by the parent component (GripAnalysisPane).
      this.itemList = [...this.gripAnalysisDetails.gripAnalysisBarriers].sort(
        (a, b) => a.id - b.id,
      );
    } else {
      this.itemList = [];
    }
    this.showBarrierDraggableBox = this.itemList.length > 0 ? false : true;
  }

  public handleShowDraggableBox(): void {
    this.showBarrierDraggableBox = true;
  }

  public onDragOver(event: any): void {
    const dragSupported = event.dataTransfer.types.length;
    if (dragSupported) {
      event.dataTransfer.dropEffect = 'copy';
      event.preventDefault();
    }
  }

  public onDrop(event: any, id: string): void {
    event.preventDefault();
    const jsonData = event.dataTransfer.getData('application/json');
    const data = JSON.parse(jsonData);
    if (!data) {
      return;
    }

    const { itemType, ...barrierData } = data;
    if (id === 'barrierDropZone' && itemType === 'barrier') {
      const barrierPayload: CreateGripAnalysisBarrierPayload = {
        ...barrierData,
        gripAnalysisId: this.gripAnalysisDetails.id,
      };
      this.$emit('addGripAnalysisBarrier', { barrierPayload, isNew: false });
    }
  }

  private _resetLocalModalState(): void {
    this.isModalActive = false;
    this.isMinimized = false;
    this.gripBarrierDetailsForEdit = null;
    this.isNew = false; // Reset isNew as well
    this.modalKey += 1; // Increment key to re-render modal if needed
  }

  public openBarrierModal(): void {
    this._resetLocalModalState();
    this.isNew = true;
    this.isModalActive = true;
  }

  public handleEdit(barrier: GripAnalysisBarrier): void {
    const {
      gripAnalysisEnablers,
      status,
      createdDate,
      updatedDate,
      ...barrierDetails
    } = barrier;
    this._resetLocalModalState();
    this.gripBarrierDetailsForEdit = barrierDetails as GripBarrierDTO;
    this.isNew = false;
    this.isModalActive = true;
  }

  public async closeBarrierModal(): Promise<void> {
    // The unsaved changes dialog, "Changes discarded" toast, and
    // `notifyKeepEditingSelected` (if user chose to keep editing)
    // are now handled by InteractiveModal before it emits the 'close' event.
    // When this method is called (in response to the @close event
    // from BarrierModal -> InteractiveModal), we can assume it's safe to close
    // and reset local state.
    // The notifyModalClosed() call is also implicitly handled by InteractiveModal
    // when its isModalActive prop (controlled here via _resetLocalModalState)
    // becomes false.
    this._resetLocalModalState();
  }

  public handleBarrierCreate(gripBarrier: CreateGripBarrierBase): void {
    const barrierPayload: CreateGripAnalysisBarrierPayload = {
      ...gripBarrier,
      gripAnalysisId: this.gripAnalysisDetails.id,
    };
    this.$emit('addGripAnalysisBarrier', {
      barrierPayload,
      isNew: true,
    });
    this._resetLocalModalState();
    this.showBarrierDraggableBox = false;
  }

  public minimizeBarrierModal(): void {
    this.isMinimized = true;
  }

  public restoreBarrierModal(): void {
    this.isMinimized = false;
  }

  public handleBarrierUpdate(
    gripBarrierUpdateData: UpdateGripBarrierBase & { id: number },
  ): void {
    // MODIFICATION START: Destructure to check if there are actual changes
    const { id, ...changesToApply } = gripBarrierUpdateData;
    let actualChangesExist = Object.keys(changesToApply).length > 0;

    // If the only "change" is to 'action' but its value hasn't changed from the original,
    // and 'reason' is null/empty (relevant when 'action' is true), it might not be a real change.
    // This part might need more sophisticated deep comparison if complex objects are involved.
    // For now, relying on Object.keys(changesToApply).length is a good first step.
    // A more robust check would involve comparing `gripBarrierUpdateData` with `this.gripBarrierDetailsForEdit`.

    if (this.gripBarrierDetailsForEdit) {
      let hasMeaningfulChange = false;
      for (const key in changesToApply) {
        if (changesToApply.hasOwnProperty(key)) {
          const originalValue = (this.gripBarrierDetailsForEdit as any)[key];
          const newValue = (changesToApply as any)[key];
          if (JSON.stringify(originalValue) !== JSON.stringify(newValue)) {
            // Special handling for 'reason' when 'action' is true
            if (
              key === 'reason' &&
              this.gripBarrierDetailsForEdit.action &&
              (newValue === null || newValue === '')
            ) {
              // If action is true, reason becoming null/empty isn't a change if it was already so
              if (originalValue !== null && originalValue !== '') {
                hasMeaningfulChange = true;
                break;
              }
            } else {
              hasMeaningfulChange = true;
              break;
            }
          }
        }
      }
      actualChangesExist = hasMeaningfulChange;
    }

    if (actualChangesExist) {
      this.$emit('updateGripAnalysisBarrier', {
        ...gripBarrierUpdateData, // Send all data including ID
        gripAnalysisId: this.gripAnalysisDetails.id,
      });
      this.$emit('handleUpdatedItemReload', {
        item: GripItemType.AnalysisBarrier,
        id: gripBarrierUpdateData.id,
        prevItemId: this.getPrevItemId(gripBarrierUpdateData.id),
      });
    }
    // Always close modal and notify, regardless of whether an API call was made.
    this._resetLocalModalState();
  }

  public handleDelete(gripAnalysisBarrierId: number): void {
    this.$buefy.modal.open({
      parent: this,
      component: DeleteModalBox,
      hasModalCard: true,
      trapFocus: true,
      props: {
        modalTitle: 'Delete Barrier?',
        modalContent:
          'Are you sure you want to delete this barrier? This action cannot be undone.',
      },
      events: {
        close: () => {
          this.$emit('close');
        },
        confirm: () => {
          this.$emit('deleteGripAnalysisBarrier', gripAnalysisBarrierId);
          this.$emit('handleUpdatedItemReload', {
            item: GripItemType.AnalysisBarrier,
            id: gripAnalysisBarrierId,
            prevItemId: this.getPrevItemId(gripAnalysisBarrierId),
          });
        },
      },
    });
  }

  public getPrevItemId(gripBarrierId: number): string | null {
    const barrierIndex: number = this.itemList.findIndex(
      (item) => item.id === gripBarrierId,
    );

    return barrierIndex > 0
      ? GripItemType.AnalysisBarrier + '_' + this.itemList[barrierIndex - 1].id
      : null;
  }

  public handleUpdatedItemReload(data: GripItemReloadDTO): void {
    this.$emit('handleUpdatedItemReload', data);
  }

  public handleAddGripAnalysisEnabler(enablerDetails: {
    enablerPayload: CreateGripAnalysisEnablerPayload;
    isNew: boolean;
  }): void {
    this.$emit('addGripAnalysisEnabler', enablerDetails);
  }

  public handleUpdateGripAnalysisEnabler(
    enablerPayload: UpdateGripAnalysisEnablerPayload,
  ): void {
    this.$emit('updateGripAnalysisEnabler', enablerPayload);
  }

  public handleDeleteGripAnalysisEnabler(gripAnalysisEnablerId: number): void {
    this.$emit('deleteGripAnalysisEnabler', gripAnalysisEnablerId);
  }

  public handleAddGripAnalysisStrategy(strategyDetails: {
    strategyPayload: CreateGripAnalysisStrategyPayload;
    isNew: boolean;
  }): void {
    this.$emit('addGripAnalysisStrategy', strategyDetails);
  }

  public handleUpdateGripAnalysisStrategy(
    strategyPayload: UpdateGripAnalysisStrategyPayload,
  ): void {
    this.$emit('updateGripAnalysisStrategy', strategyPayload);
  }

  public handleDeleteGripAnalysisStrategy(
    gripAnalysisStrategyId: number,
  ): void {
    this.$emit('deleteGripAnalysisStrategy', gripAnalysisStrategyId);
  }

  @Watch('userSelectedKeepEditing')
  public onUserSelectedKeepEditing(newValue: boolean): void {
    this.resetKeepEditingFlag();
    if (newValue && this.isMinimized && this.isModalActive) {
      this.restoreBarrierModal();
    }
  }
}
